import { ref, watch } from 'vue'
import { Travel, Route } from '@/types/TravelTypes'

export function useTravelMapping(props: {
  travels: Travel[]
  services?: any[]
}) {
  const mappedTravels = ref<any[]>([])

  const updateMappedTravels = () => {
    
    if (!props.travels || !props.travels.length) {
      mappedTravels.value = []
      return
    }
    
    if (!props.services || !props.services.length) {
      mappedTravels.value = props.travels.map(travel => ({
        ...travel,
        routes: (travel.routes || []).map((route: Route) => ({
          ...route,
          meta_data: [],
          via_stations: [],
          route_codes: Array.isArray(route.route_codes) ? route.route_codes : [],
          travel_duration: route.travel_duration || '',
        }))
      }))
      return
    }

    mappedTravels.value = props.travels.map((travel) => {
      const mappedTravel = {
        ...travel,
        routes: (travel.routes || []).map((route: Route) => {
          let service = undefined
          if (route.legs && route.legs.length > 0 && route.legs[0].service_identifier) {
            service = props.services?.find(
              (service) =>
                service.service_identifier === route.legs[0].service_identifier
            )
          } else {
            service = props.services?.find(
              (service) =>
                service.service_identifier === route.id
            )
          }

          // Ensure route_codes is always an array
          const routeCodes = Array.isArray(route.route_codes)
            ? route.route_codes
            : []

          return {
            ...route,
            meta_data: service?.meta_data || [],
            via_stations: service?.via_stations || [],
            route_codes: routeCodes,
            travel_duration: route.travel_duration || '',
          }
        }),
      }
      return mappedTravel
    })
  }

  watch(() => props.travels, updateMappedTravels, { immediate: true })
  watch(() => props.services, updateMappedTravels, { immediate: true })

  const updateRouteCodes = (
    travelIndex: number,
    routeIndex: number,
    routeCodes: string[]
  ) => {
    mappedTravels.value = mappedTravels.value.map((travel, idx) => {
      if (idx !== travelIndex) return travel

      return {
        ...travel,
        routes: (travel.routes || []).map((route: Route, rIdx: number) => {
          if (rIdx !== routeIndex) return route

          return {
            ...route,
            route_codes: routeCodes,
          }
        }),
      }
    })
  }

  return {
    mappedTravels,
    updateRouteCodes,
  }
}
